// @flow
import { Schema } from "../../../components/form";

const formSchema = new Schema({
  number: {
    type: "string",
    required: true
  },
  name: {
    type: "string",
    required: true
  },
  expiry: {
    type: "string",
    required: true
  },
  cvc: {
    type: "string",
    required: true
  },
  cpf: {
    type: "string",
    required: true,
    validator: cpf => {
      cpf = cpf.replace(/[^\d]+/g, "");
      if (cpf === "") return "CPF inválido";

      if (
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
      )
        return "CPF inválido";

      let add = 0;
      //eslint-disable-next-line radix
      for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      //eslint-disable-next-line radix
      if (rev !== parseInt(cpf.charAt(9))) return "CPF inválido";

      add = 0;
      //eslint-disable-next-line radix
      for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      //eslint-disable-next-line radix
      if (rev !== parseInt(cpf.charAt(10))) return "CPF inválido";
      return "";
    }
  },
  cep: {
    type: "string",
    required: true
  },
  address: {
    type: "string",
    required: true,
    validator: address => {
      if (address.length > 60) {
        return "Rua inválida. Limite máximo de 60 caracteres";
      }
    }
  },
  numberAddress: {
    type: "string",
    validator: numberAddress => {
      if (numberAddress.length > 9) {
        return "Número inválido";
      }
    }
  },
  comp: {
    type: "string",
    validator: comp => {
      if (comp.length > 30) {
        return "Complemento inválido. Limite máximo de 30 caracteres";
      }
    }
  },
  neighborhood: {
    type: "string",
    required: true,
    validator: neighborhood => {
      if (neighborhood.length > 50) {
        return "Bairro inválido. Limite máximo de 50 caracteres";
      }
    }
  },
  installments: {
    type: "string",
    required: true
  },
  city: {
    type: "string",
    required: true
  },
  uf: {
    type: "string",
    required: true,
    validator: uf => {
      if (uf.length !== 2) {
        return "UF inválido";
      }
    }
  },
  recurrence: {
    type: "boolean"
  }
});

export default formSchema;
